import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = ["fill"]
const _hoisted_3 = ["fill"]

import { withDefaults } from 'vue';

interface IProps {
  color?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ShowIcon',
  props: {
    color: null
  },
  setup(__props: any) {

const props = __props as { color?: string };



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("path", {
      opacity: "0.4",
      d: "M28.3334 12.2C25.2534 7.36 20.7467 4.57333 16.0001 4.57333C13.6267 4.57333 11.3201 5.26667 9.21341 6.56C7.10675 7.86667 5.21341 9.77333 3.66675 12.2C2.33341 14.2933 2.33341 17.6933 3.66675 19.7867C6.74675 24.64 11.2534 27.4133 16.0001 27.4133C18.3734 27.4133 20.6801 26.72 22.7867 25.4267C24.8934 24.12 26.7867 22.2133 28.3334 19.7867C29.6667 17.7067 29.6667 14.2933 28.3334 12.2ZM16.0001 21.3867C13.0134 21.3867 10.6134 18.9733 10.6134 16C10.6134 13.0267 13.0134 10.6133 16.0001 10.6133C18.9867 10.6133 21.3867 13.0267 21.3867 16C21.3867 18.9733 18.9867 21.3867 16.0001 21.3867Z",
      fill: __props.color ||'#697B8E'
    }, null, 8, _hoisted_2),
    _createElementVNode("path", {
      d: "M16 12.1867C13.9066 12.1867 12.2 13.8933 12.2 16C12.2 18.0933 13.9066 19.8 16 19.8C18.0933 19.8 19.8133 18.0933 19.8133 16C19.8133 13.9067 18.0933 12.1867 16 12.1867Z",
      fill: __props.color ||'#697B8E'
    }, null, 8, _hoisted_3)
  ]))
}
}

})